import { render, staticRenderFns } from "./GameLogo.vue?vue&type=template&id=7087161a&scoped=true&"
import script from "./GameLogo.vue?vue&type=script&lang=js&"
export * from "./GameLogo.vue?vue&type=script&lang=js&"
import style0 from "./GameLogo.vue?vue&type=style&index=0&id=7087161a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7087161a",
  null
  
)

export default component.exports